import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateFavourite } from '../utils/validate-favourite';
import { FavouriteContainerProps } from '../types';
import { FavouriteStickyHeader } from './favourite-sticky-header';
import { getFavouriteName } from 'app/area/favourite-administration/form/components/helpers';

export const FavouriteContainer: React.FC<FavouriteContainerProps> = ({
  formState, mainLanguage, shouldPrompt, children, locale, translation,
  switchTranslationsToggle, saveFavourite, deleteFavourite, updateValidation, displayError
}) => {

  const { favouriteItem, saving, deleting, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateFavourite(favouriteItem, languageOptions, translation);

    updateValidation({ ...validation, ...formValidation });

    if (Object.keys(formValidation).length > 0) {
      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.favourite_validation_error);
      return;
    }

    saveFavourite(favouriteItem);
  };

  const favouriteName = getFavouriteName(favouriteItem, mainLanguage);

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_favourite
        : translation.deleting_favourite} />
    <FavouriteStickyHeader
      favouriteItem={favouriteItem}
      name={favouriteName}
      shouldPrompt={shouldPrompt}
      deleting={deleting}
      displayError={displayError}
      onSave={onSave}
      onDelete={deleteFavourite}
      locale={locale}
      translation={translation} />
    {children}
  </>;
};
